import { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Snackbar,
  Alert,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from "@mui/material";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function FormRegister() {

  const token = localStorage.getItem("accessToken");
const [modules, setModules] = useState([]);
  const [forms, setForms] = useState([]);
  const [search, setSearch] = useState("");

  const [openForm, setOpenForm] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);

  const [editId, setEditId] = useState(null);
  const [deleteId, setDeleteId] = useState(null);

  const [formData, setFormData] = useState({
    module: "",
    form_name: "",
    route: "",
    description: "",
    icon: "",
    order: ""
  });

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  /* ============================
        GET ALL FORMS
  ============================ */

  const fetchForms = async () => {
    try {

      const response = await axios.get(
        `${API_BASE_URL}/api/elearning_settings/forms/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const formList = (response.data.results || response.data).map((f) => ({
        ...f,
        id: f.id || f.form_id
      }));

      setForms(formList);

    } catch (error) {
      console.log("FORM LIST ERROR:", error.response);
    }
  };
 const fetchModules = async () => {
  try {

    const response = await axios.get(
      `${API_BASE_URL}/api/elearning_settings/modules/`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setModules(response.data.results || response.data);

  } catch (error) {
    console.log("MODULE LIST ERROR:", error.response);
  }
};

  useEffect(() => {
  fetchForms();
  fetchModules();
}, []);

  /* ============================
        GET FORM BY ID
  ============================ */

 const fetchFormById = async (id) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/api/elearning_settings/forms/${id}/`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    
    const data = response.data;
    
    // Handle both possible response shapes from Django REST
    // 1. Nested object:    "module": { "module_id": 1, "module_name": "..." }
    // 2. ID only:          "module": 1
    const moduleValue = data.module?.module_id ?? data.module ?? "";

    setFormData({
      module: moduleValue,               // will be number or string
      form_name: data.form_name || "",
      route: data.route || "",
      description: data.description || "",
      icon: data.icon || "",
      order: data.order || ""
    });

    setEditId(id);
    setOpenForm(true);

    // Debug (remove later if not needed)
    console.log("Fetched form data:", data);
    console.log("Selected module value:", moduleValue, typeof moduleValue);

  } catch (error) {
    console.log("FORM DETAIL ERROR:", error?.response?.data || error);
  }
};



  /* ============================
        CREATE FORM
  ============================ */

  const createForm = async () => {

    try {

      await axios.post(
        `${API_BASE_URL}/api/elearning_settings/forms/`,
        {
          ...formData,
          order: Number(formData.order)
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setSnackbarMessage("Form created successfully");
      setSnackbarSeverity("success");
      setOpenSnackbar(true);

      setOpenForm(false);
      fetchForms();

    } catch (error) {
      console.log("FORM CREATE ERROR:", error.response);
    }
  };

  /* ============================
        UPDATE FORM
  ============================ */

  const updateForm = async () => {

    try {

      await axios.put(
        `${API_BASE_URL}/api/elearning_settings/forms/${editId}/`,
        {
          ...formData,
          order: Number(formData.order)
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setSnackbarMessage("Form updated successfully");
      setSnackbarSeverity("success");
      setOpenSnackbar(true);

      setOpenForm(false);
      fetchForms();

    } catch (error) {
      console.log("FORM UPDATE ERROR:", error.response);
    }
  };

  /* ============================
        DELETE FORM
  ============================ */

  const confirmDelete = async () => {

    try {

      await axios.delete(
        `${API_BASE_URL}/api/elearning_settings/forms/${deleteId}/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setSnackbarMessage("Form deleted successfully");
      setSnackbarSeverity("success");
      setOpenSnackbar(true);

      setOpenDelete(false);
      fetchForms();

    } catch (error) {
      console.log("FORM DELETE ERROR:", error.response);
    }
  };

  /* ============================
        SEARCH
  ============================ */

  const filteredForms = forms.filter((f) =>
    f.form_name?.toLowerCase().includes(search.toLowerCase())
  );

  return (

    <Paper sx={{ p: 4 }}>

      <Typography variant="h5" fontWeight="bold" mb={3}>
        Form Details
      </Typography>

      {/* Search + Add */}

      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>

        <TextField
          size="small"
          placeholder="Search"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <Button
          variant="contained"
          onClick={() => {

            setEditId(null);

            setFormData({
              module: "",
              form_name: "",
              route: "",
              description: "",
              icon: "",
              order: ""
            });

            setOpenForm(true);
          }}
        >
          ADD FORM
        </Button>

      </Box>

      {/* TABLE */}

      <TableContainer>

        <Table>

          <TableHead>
            <TableRow>

              <TableCell>S.No</TableCell>
              <TableCell>Module</TableCell>
              <TableCell>Form Name</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Route</TableCell>
              <TableCell>Order</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>

            {filteredForms.map((row, index) => (

              <TableRow key={row.id}>

                <TableCell>{index + 1}</TableCell>
                <TableCell>{row.module}</TableCell>
                <TableCell>{row.form_name}</TableCell>
                <TableCell>{row.description}</TableCell>
                <TableCell>{row.route}</TableCell>
                <TableCell>{row.order}</TableCell>

                <TableCell>

                  <Button
                    size="small"
                    sx={{ mr: 1, bgcolor: "#facc15", color: "#000" }}
                    onClick={() => fetchFormById(row.id)}
                  >
                    EDIT
                  </Button>

                  <Button
                    size="small"
                    color="error"
                    variant="contained"
                    onClick={() => {
                      setDeleteId(row.id);
                      setOpenDelete(true);
                    }}
                  >
                    DELETE
                  </Button>

                </TableCell>

              </TableRow>

            ))}

          </TableBody>

        </Table>

      </TableContainer>

      {/* ADD / EDIT FORM */}

      <Dialog open={openForm} onClose={() => setOpenForm(false)}>

        <DialogTitle>
          {editId ? "Edit Form" : "Add Form"}
        </DialogTitle>

        <DialogContent>
{/* --- ADD THESE LINES HERE --- */}
  {console.log("Available Modules:", modules)}
  {console.log("Current Selected Module ID:", formData.module)}
  {/* ---------------------------- */}

    <FormControl fullWidth margin="dense">
  <InputLabel>Module</InputLabel>
  <Select
    value={formData.module ? String(formData.module) : ""}
    label="Module"
    onChange={(e) => setFormData({ ...formData, module: e.target.value })}
    disabled={modules.length === 0}
  >
    {modules.length === 0 ? (
      <MenuItem value="" disabled>
        No modules found
      </MenuItem>
    ) : (
      modules.map((module) => (
        <MenuItem 
          key={module.module_id} 
          value={String(module.module_id)}          // ← fixed: use module_id
        >
          {module.module_name || "Unnamed"} (ID: {module.module_id})
        </MenuItem>
      ))
    )}
  </Select>
</FormControl>


          <TextField
            fullWidth
            label="Form Name"
            margin="dense"
            value={formData.form_name}
            onChange={(e) =>
              setFormData({ ...formData, form_name: e.target.value })
            }
          />

          <TextField
            fullWidth
            label="Route"
            margin="dense"
            value={formData.route}
            onChange={(e) =>
              setFormData({ ...formData, route: e.target.value })
            }
          />

          <TextField
            fullWidth
            label="Description"
            margin="dense"
            value={formData.description}
            onChange={(e) =>
              setFormData({ ...formData, description: e.target.value })
            }
          />

          <TextField
            fullWidth
            label="Icon"
            margin="dense"
            value={formData.icon}
            onChange={(e) =>
              setFormData({ ...formData, icon: e.target.value })
            }
          />

          <TextField
            fullWidth
            label="Order"
            margin="dense"
            value={formData.order}
            onChange={(e) =>
              setFormData({ ...formData, order: e.target.value })
            }
          />

        </DialogContent>

        <DialogActions>

          <Button onClick={() => setOpenForm(false)} data-app-cancel="true">
            Cancel
          </Button>

          {editId ? (
            <Button variant="contained" onClick={updateForm}>
              Update
            </Button>
          ) : (
            <Button variant="contained" onClick={createForm}>
              Save
            </Button>
          )}

        </DialogActions>

      </Dialog>

      {/* DELETE CONFIRM */}

      <Dialog open={openDelete} onClose={() => setOpenDelete(false)}>

        <DialogTitle>Confirm Delete</DialogTitle>

        <DialogContent>
          Are you sure you want to delete this form?
        </DialogContent>

        <DialogActions>

          <Button onClick={() => setOpenDelete(false)} data-app-cancel="true">
            Cancel
          </Button>

          <Button
            variant="contained"
            color="error"
            onClick={confirmDelete}
          >
            Delete
          </Button>

        </DialogActions>

      </Dialog>

      {/* SNACKBAR */}

      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >

        <Alert
          severity={snackbarSeverity}
          onClose={() => setOpenSnackbar(false)}
        >
          {snackbarMessage}
        </Alert>

      </Snackbar>

    </Paper>
  );
}

export default FormRegister;